const App = {
  namespaced: true,

  state: {
    drawer: true,

    activeDepotId: null,
    activeDepotTk: null,
    activeDepotPix: null,
  },
  getters: {
    getDrawer: state => state.drawer
  },
  mutations: {
    setDrawer(state, payload) {
      state.drawer = payload;
    },
    setDepot(state, depot_id){
      const local = localStorage.getItem('depot_id')
      if (depot_id){
        state.activeDepotId = depot_id
        localStorage.setItem('depot_id', state.activeDepotId)
      } else {
        state.activeDepotId = local
      }
    },
    setDepotTk(state, depot_tk){
      const local = localStorage.getItem('depot_tk')
      if (depot_tk){
        state.activeDepotTk = depot_tk
        localStorage.setItem('depot_tk', state.activeDepotTk)
      } else {
        state.activeDepotTk = local
      }
    },
    setDepotPix(state, depot_company_pix){
      const local = localStorage.getItem('depot_company_pix')
      if (depot_company_pix){
        state.activeDepotPix = depot_company_pix
        localStorage.setItem('depot_company_pix', state.activeDepotPix)
      } else {
        state.activeDepotPix = local
      }
    },
  },
  actions: {
    setDrawer(context, payload) {
      context.commit("setDrawer", payload);
    },

    setActiveDepotId(context, depot_id) {
      context.commit("setDepot", depot_id);
    },
    setActiveDepotTk(context, depot_tk) {
      context.commit("setDepotTk", depot_tk);
    },
    setActiveDepotPix(context, depot_company_pix) {
      context.commit("setDepotPix", depot_company_pix);
    }
  }
};

export default App;
